import { render, staticRenderFns } from "./DebtorAgingReportSideMenu.vue?vue&type=template&id=21343643&scoped=true"
import script from "./DebtorAgingReportSideMenu.vue?vue&type=script&lang=js"
export * from "./DebtorAgingReportSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21343643",
  null
  
)

export default component.exports